import React from 'react';

import './ImageScrollbar.css';

const keys = {
	// ArrowLeft: 'ArrowLeft',
	// ArrowRight: 'ArrowRight',
	ArrowUp: 'ArrowUp',
	ArrowDown: 'ArrowDown'
};

interface ImageScrollbarProps {
	value: number;
	max: number;
	height: string;
	onChange: (value: number) => void;
	onContextMenu?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const ImageScrollbar: React.FC<ImageScrollbarProps> = ({
	value,
	max,
	height,
	onChange,
	onContextMenu = (e: React.MouseEvent<HTMLDivElement>) => e.preventDefault()
}) => {
	if (max === 0) {
		return null;
	}

	const style = {
		width: `${height}`
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const intValue = parseInt(event.target.value, 10);
		onChange(intValue);
	};

	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		// We don't allow direct keyboard up/down input on the
		// image sliders since the natural direction is reversed (0 is at the top)

		if (event.key === keys.ArrowDown) {
			// Increment the value (move down)
			const newValue = Math.min(value + 1, max);
			onChange(newValue);
			event.preventDefault();
		} else if (event.key === keys.ArrowUp) {
			// Decrement the value (move up)
			const newValue = Math.max(value - 1, 0);
			onChange(newValue);
			event.preventDefault();
		}
	};

	return (
		<div className="scroll" onContextMenu={onContextMenu}>
			<div className="scroll-holder">
				<input
					// adding mousetrap let the mousetrap know about the scrollbar otherwise,
					// it will not capture the keyboard event
					className="imageSlider mousetrap"
					style={style}
					type="range"
					min="0"
					max={max}
					step="1"
					value={value}
					onChange={handleChange}
					onKeyDown={handleKeyDown}
				/>
			</div>
		</div>
	);
};

export default ImageScrollbar;
